import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { SagaIterator } from 'redux-saga';
import { call, cancelled, delay, select } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { IAppState } from '../../localStore';

const globalActions = new GlobalActions();
export const addTaasLoadingActions = (
  generatorFunction: (action: AnyAction) => IterableIterator<unknown>,
) => {
  return function* (action: AnyAction): SagaIterator {
    const globalPut = GlobalPut.getInstance();
    const state: IAppState = (yield select()) as IAppState;
    yield call(globalPut.put, globalActions.settingsReceived(state.transientState.settings));
    yield call(
      globalPut.put,
      globalActions.featuretoggleReceived(state.transientState.featureToggles),
    );
    yield call(
      globalPut.put,
      globalActions.kooperationenListReceived(state.transientState.kooperationen),
    );
    yield call(globalPut.put, globalActions.tarifierungHasStarted());
    try {
      yield call(generatorFunction, action);
    } finally {
      if (yield cancelled()) {
        yield delay(0);
        yield call(globalPut.put, globalActions.tarifierungRunReleased());
      } else {
        yield call(globalPut.put, globalActions.tarifierungHasEnded());
      }
    }
  };
};
